/*----- Core -----*/
import React, { useState } from 'react'
import { connect }         from "react-redux"

/*----- Styles -----*/
import Styles from './Styles'

/*----- Ant Design -----*/
import { Row, Col, Input, Form, DatePicker, InputNumber, Checkbox } from 'antd'

/*----- Utils -----*/
import StringToSlug    					from '../../../../utils/StringToSlug'
import StringTitleCase      		from '../../../../utils/StringTitleCase'

/*----- Selectors -----*/
import { producerIsLoadingSelector } from './Selectors.js'

/*----- Actions -----*/
import { createProducer } from './Actions'

/*----- Components -----*/
import SectionContainer   from '../../../../components/commons/SectionContainer'
import InputContainer     from '../../../../components/form/InputContainer'
import HandlerButton      from '../../../../components/button/HandlerButton'
import Spinner            from '../../../../components/commons/Spinner'
import Title              from '../../../../components/text/Title'
import PageTitle 					from '../../../../components/text/PageTitle'
import imageReader 				from '../../../../components/imageProcessor/index'
import ImageVisualizer 		from '../../../../components/imageProcessor/ImageVisualizer'
import Paragraph 		      from '../../../../components/text/Paragraph'

/*----- Export -----*/
function CreateProducerForm({ createProducer, producerIsLoading}) {

	const [form]																= Form.useForm()
	const [images, setImages] 									= useState(null)
	const [imagesIsLoading, setImagesIsLoading] = useState(false)
	const [visible, setIvisible]                = useState(true)
	const [active, setActive]                   = useState(true)

	const resetAllFields = () => {
		form.resetFields()
		setImages(null)
	}
		
	// Object ready to send 
	const sanitizedValues = (values) => {
		const { 
			name, 
			lastname,
			birth_date,
			phone,
			office_address,
			address,
			communication_channels
		} = values
		return {
			name: 				  				StringTitleCase( name ),
			lastname:			  				StringTitleCase( lastname ),
			name_slug: 		  				StringToSlug(`${name} ${lastname}`),
			birth_date: 	  				birth_date.format('YYYY-MM-DD'),
			phone:      	  				{ area_code: phone.area_code || null, number: phone.number || null },
			office_address:         { ...office_address, floor: office_address.floor || null, department: office_address.department || null },
			address:         			  {  street: address.street || null, number: address.number || null, floor: address.floor || null, department: address.department || null },
			communication_channels: { ...communication_channels, web: communication_channels.web || null, facebook: communication_channels.facebook || null, instagram: communication_channels.instagram || null }
		}
	}
	const onFinish = (values, creationFunction) => {
		creationFunction(
			{
				...values,
				...sanitizedValues(values),
				created_at: new Date(),
				visible:    visible,
				active:     active,
				images:     images,
			}
		)
		resetAllFields()
	}
	const onFinishFailed = (errors) => {
		console.log(errors)
	}
	const onImageChange = (e) => {
		let files = e.target.files
			imageReader(files, setImagesIsLoading)
			.then((readyImages)=>{
				setImages(readyImages)
				setImagesIsLoading(false)
			})
	}

	const onVisibilityChange = (e) => {
		return setIvisible(!visible)
	}

	const onActiveChange = (e) => {
		return setActive(!active)
	}

	if(producerIsLoading) {
		return (
			<Styles>
				<div className="spinner-container">
					<Spinner/>
				</div>
			</Styles>
		)
	}
	return (
		<Styles>
			<SectionContainer>

				<PageTitle content="Crear productor" />

				<Form
					layout				 = "vertical"
					name           =  "create-producer-form"
					form           = { form }
					onFinish       = { (values) => onFinish(values, createProducer) }
					onFinishFailed = { onFinishFailed }
					initialValues  = {{
						phone: {
							area_code: null,
							number: null
						},
						office_address: {
							floor: null,
							department: null
						},
						address: {
							street: null,
							number: null,
							floor: null,
							department: null
						},
						communication_channels: {
							web: null,
							facebook: null,
							instagram: null
						}
					}}
				>
				
						<Row gutter={32}>
							<Col xs={24} sm={24} md={24} lg={10} xl={8}>
								<Title content="Foto de perfíl" size={4}/>
								<ImageVisualizer images={images} imagesIsLoading={imagesIsLoading} onChange={onImageChange} />
							</Col>
							<Col xs={24} sm={24} md={24} lg={10} xl={10}>
								<Title content="Visibilidad del productor" size={4}/>
								<Paragraph content="Desmarcá esta opción si queres que el productor no sea público en la web."/>
								<Checkbox checked={visible} onChange={onVisibilityChange}>Perfil público</Checkbox>
								<Title content="Actividad del productor" size={4}/>
								<Paragraph content="Desmarcá esta opción si el productor que estas cargando se encuentra actualmente inactivo."/>
								<Checkbox checked={active}	onChange={onActiveChange} >Productor en actividad</Checkbox>
							</Col>
						</Row>

						<Row gutter={32}>
							<Col xs={24} sm={24} md={24} lg={20} xl={18}>
								<Title content="Datos personales" size={4}/>
								<Input.Group size="large">
									<Row gutter={16}>
										<Col xs={24} sm={24} md={24} lg={12} xl={12}>
											<InputContainer>
												<Form.Item
													label       = "nombre"
													name			  = "name"
													rules				= {[{ required: true, message: 'Nombre requerido' }]}
												>
													<Input placeholder="Nombre"/>
												</Form.Item>
											</InputContainer>
										</Col>
										<Col xs={24} sm={24} md={24} lg={12} xl={12}>
											<InputContainer>
												<Form.Item
													label       = "apellido"
													name			  = "lastname"
													rules				= {[{ required: true, message: 'Apellido requerido' }]}
												>
													<Input placeholder="Apellido"/>
												</Form.Item>
											</InputContainer>
										</Col>
									</Row>
								</Input.Group>

								<Input.Group size="large">
									<Row gutter={16}>
										<Col xs={24} sm={24} md={24} lg={8} xl={8}>
											<InputContainer>
												<Form.Item
													label       = "ID de productor"
													name			  = "producer_id"
													rules				= {[{ required: true, message: 'Campo requerido' }]}
												>
													<InputNumber style={{width: '100%'}} size="large" placeholder="Número de PAS" />
												</Form.Item>
											</InputContainer>
										</Col>
										<Col xs={24} sm={24} md={24} lg={8} xl={8}>
											<InputContainer>
												<Form.Item
													label       = "cuit"
													name			  = "cuit_number"
													rules				= {[{ required: true, message: 'Campo requerido' }]}
												>
													<InputNumber style={{width: '100%'}} size="large" placeholder="Número de CUIT" />
												</Form.Item>
											</InputContainer>
										</Col>
										<Col xs={24} sm={24} md={24} lg={8} xl={8}>
											<InputContainer>
												<Form.Item
													label       = "mat ssn"
													name			  = "mat_number"
													rules				= {[{ required: true, message: 'Campo requerido' }]}
												>
													<InputNumber style={{width: '100%'}} size="large" placeholder="Número de matrícula" />
												</Form.Item>
											</InputContainer>
										</Col>
									</Row>
								</Input.Group>

								<Row>
									<Col xs={24} sm={24} md={24} lg={12} xl={12}>
										<InputContainer>
											<Form.Item
												label       = "fecha de nacimiento"
												name			  = "birth_date"
												rules				= {[{ required: true, message: 'Ingresá fecha de nacimiento' }]}
											>
												<DatePicker size="large" style={{width: '100%'}} />
											</Form.Item>
										</InputContainer>
									</Col>
								</Row>


								<Row gutter={32}>
									<Col xs={24} sm={24} md={24} lg={12} xl={12}>
										<Title content="Teléfono comercial" size={6}/>
										<Row gutter={16}>
											<Col xs={24} sm={24} md={24} lg={12} xl={12}>
												<InputContainer>
													<Form.Item
														label       = "código de area"
														name			  = {['business_phone', 'area_code']}
														rules				= {[{ required: true, message: 'Campo requerido' }]}
													>
														<InputNumber style={{width: '100%'}} size="large" placeholder="Código" />
													</Form.Item>
												</InputContainer>
											</Col>
											<Col xs={24} sm={24} md={24} lg={12} xl={12}>
												<InputContainer>
													<Form.Item
														label       = "número"
														name			  = {['business_phone', 'number']}
														rules				= {[{ required: true, message: 'Campo requerido' }]}
													>
														<InputNumber style={{width: '100%'}} size="large" placeholder="Número" />
													</Form.Item>
												</InputContainer>
											</Col>
										</Row>
									</Col>
									<Col xs={24} sm={24} md={24} lg={12} xl={12}>
										<Title content="Teléfono particular" size={6}/>
										<Row gutter={16}>
											<Col xs={24} sm={24} md={24} lg={12} xl={12}>
												<InputContainer>
													<Form.Item
														label       = "código de area"
														name			  = {['phone', 'area_code']}
													>
														<InputNumber style={{width: '100%'}} size="large" placeholder="Código" />
													</Form.Item>
												</InputContainer>
											</Col>
											<Col xs={24} sm={24} md={24} lg={12} xl={12}>
												<InputContainer>
													<Form.Item
														label       = "número"
														name			  = {['phone', 'number']}
													>
														<InputNumber style={{width: '100%'}} size="large" placeholder="Número" />
													</Form.Item>
												</InputContainer>
											</Col>
										</Row>
									</Col>
								</Row>

								<Title content="Dirección de oficina o lugar de trabajo" size={6}/>
								<Input.Group size="large">
									<Row gutter={16}>
										<Col xs={24} sm={12} md={12} lg={12} xl={6}>
											<InputContainer>
												<Form.Item
													label  = "calle"
													name	 = {['office_address', 'sreet']}
													rules  = {[{ required: true, message: 'Campo requerido' }]}
												>
													<Input placeholder="Calle"/>
												</Form.Item>
											</InputContainer>
										</Col>
										<Col xs={24} sm={12} md={12} lg={12} xl={6}>
											<InputContainer>
												<Form.Item
													label  = "numeración"
													name	 = {['office_address', 'number']}
													rules  = {[{ required: true, message: 'Campo requerido' }]}
												>
													<InputNumber style={{width: '100%'}} size="large" placeholder="Número"/>
												</Form.Item>
											</InputContainer>
										</Col>
										<Col xs={24} sm={12} md={12} lg={12} xl={6}>
											<InputContainer>
												<Form.Item
													label  = "piso"
													name	 = {['office_address', 'floor']}
												>
													<InputNumber style={{width: '100%'}} size="large" placeholder="Piso"/>
												</Form.Item>
											</InputContainer>
										</Col>
										<Col xs={24} sm={12} md={12} lg={12} xl={6}>
											<InputContainer>
												<Form.Item
													label  = "departamento"
													name   = {['office_address', 'department']}
												>
													<Input placeholder="Departamento"/>
												</Form.Item>
											</InputContainer>
										</Col>
									</Row>
								</Input.Group>
								
								<Title content="Dirección particular" size={6}/>
								<Input.Group size="large">
									<Row gutter={16}>
										<Col xs={24} sm={12} md={12} lg={12} xl={6}>
											<InputContainer>
												<Form.Item
													label  = "calle"
													name	 = {['address', 'street']}
												>
													<Input placeholder="Calle"/>
												</Form.Item>
											</InputContainer>
										</Col>
										<Col xs={24} sm={12} md={12} lg={12} xl={6}>
											<InputContainer>
												<Form.Item
													label = "numeración"
													name	= {['address', 'number']}
												>
													<InputNumber style={{width: '100%'}} size="large" placeholder="Número"/>
												</Form.Item>
											</InputContainer>
										</Col>
										<Col xs={24} sm={12} md={12} lg={12} xl={6}>
											<InputContainer>
												<Form.Item
													label = "piso"
													name	= {['address', 'floor']}
												>
													<InputNumber style={{width: '100%'}} size="large" placeholder="piso"/>
												</Form.Item>
											</InputContainer>
										</Col>
										<Col xs={24} sm={12} md={12} lg={12} xl={6}>
											<InputContainer>
												<Form.Item
													label = "departamento"
													name  = {['address', 'department']}
												>
													<Input placeholder="Departamento"/>
												</Form.Item>
											</InputContainer>
										</Col>
									</Row>
								</Input.Group>

								<Title content="Canales" size={4}/>
								<Input.Group size="large">
									<Row gutter={32}>
										<Col xs={24} sm={24} md={24} lg={12} xl={12}>
											<InputContainer>
												<Form.Item
													label       = "email"
													name			  = {['communication_channels', 'email']}
													rules				= {[{ required: true, type: "email", message: 'Campo requerido' }]}
												>
													<Input type="email" size="large" placeholder="Email"/>
												</Form.Item>
											</InputContainer>
										</Col>
										<Col xs={24} sm={24} md={24} lg={12} xl={12}>
											<InputContainer>
												<Form.Item
													label       = "web"
													name			  = {['communication_channels', 'web']}
													rules				= {[{ type: "url", message: 'Formato inválido' }]}
												>
													<Input type="url" placeholder="Sitio web" />
												</Form.Item>
											</InputContainer>
										</Col>
										<Col xs={24} sm={24} md={24} lg={24} xl={24}>
											<InputContainer>
												<Form.Item
													label       = "facebook"
													name			  = {['communication_channels', 'facebook']}
												>
													 <Input addonBefore="https://www.facebook.com/" />
												</Form.Item>
											</InputContainer>
										</Col>
										<Col xs={24} sm={24} md={24} lg={24} xl={24}>
											<InputContainer>
												<Form.Item
													label       = "instagram"
													name			  = {['communication_channels', 'instagram']}
												>
													 <Input addonBefore="https://www.instagram.com/" />
												</Form.Item>
											</InputContainer>
										</Col>
									</Row>
								</Input.Group>
							
							<InputContainer>
								<Form.Item>
									<HandlerButton content="crear" htmlType="submit" />
								</Form.Item>
							</InputContainer>	
						
						</Col>
					</Row>


						

				</Form>
			</SectionContainer>
		</Styles>
	)
}

const mapStateToProps = (state) => {
  return {
		producerIsLoading: producerIsLoadingSelector(state)
	}
}

const mapDispatchToProps = (dispatch) => {
  return {
		createProducer: (params) => createProducer(dispatch, params)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateProducerForm)

